let modal;
let closeBody;
let newsLetterSub;
let submitContainer;
let termsInput;
let submitBtn;

function handleModal() {
  const iFrame = document.querySelector('#klaviyo-bis-iframe');
  const iframeDoc = iFrame.contentDocument || iFrame.contentWindow.document;

  setTimeout(() => {
    const body = iframeDoc?.body;
    modal = body?.querySelector('#klaviyo-bis-modal');
    closeBody = modal.querySelector('.klaviyo-bis-close');
    if (!modal) return;

    showModal(true);
    moveNewsletterBelowSubmit();
    addTermsCheckbox();
    handleInputValidation();
    handleCloseButton();
    handleSlideOut(body);
  });
}

function showModal(show) {
  modal.classList.toggle('show', show);
  modal.classList.toggle('hide', !show);
  if (!show) setTimeout(() => closeBody.click(), 500);
}

function moveNewsletterBelowSubmit() {
  submitContainer = modal.querySelector('.submit-container');
  newsLetterSub = modal.querySelector('#newsletter_subscription');
  if (newsLetterSub) submitContainer?.insertAdjacentElement('afterend', newsLetterSub);
}

function addTermsCheckbox() {
  if (!newsLetterSub) return;

  const terms = newsLetterSub?.cloneNode(true);
  const termsLabel = terms?.querySelector('label');
  termsInput = terms?.querySelector('input');

  if (!termsInput || !termsLabel || !window.termsPrivacyText) return;

  termsLabel.htmlFor = 'terms_and_privacy';
  termsInput.id = 'terms_and_privacy';
  termsLabel.innerHTML = window.termsPrivacyText;
  newsLetterSub.insertAdjacentElement('afterend', terms);
}

function handleInputValidation() {
  const email = modal.querySelector('input[type="email"]');
  submitBtn = submitContainer?.querySelector('button[type="submit"]');

  if (!email || !submitBtn || !termsInput) return;

  submitBtn.disabled = true;

  [email, termsInput].forEach(input => {
    input.addEventListener('input', () => {
      if (email.value != '' & termsInput.checked) {
        submitBtn.disabled = false;
      } else {
        submitBtn.disabled = true;
      }
    })
  });
}

function handleCloseButton() {
  if (window.closeButton) submitBtn.insertAdjacentHTML('afterend', window.closeButton);
  const closeButton = modal.querySelector('.oos-close-modal');
  closeButton?.addEventListener('click', () => showModal(false));
}

function handleSlideOut(body) {
  // allow buffer time for slide out before exiting popup
  const slideOutLayer = document.createElement('div');
  slideOutLayer.className = 'trigger-slide-out';
  slideOutLayer.addEventListener('click', () => showModal(false));
  body.insertAdjacentElement('afterbegin', slideOutLayer);
}

const observer = new MutationObserver((mutationsList, observer) => {
  const modalTrigger = document.querySelector('.product__oos-trigger');

  if (modalTrigger) {
    // Hide original btn
    const ogSubmit = document.querySelector('.product__submit__holder--notification');
    if (ogSubmit) ogSubmit.style.display = 'none';

    // Add klaviyo modal
    modalTrigger?.addEventListener('click', handleModal);
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });